import React from "react";

export const PartnerLogoBox = (
    /** @type {{ logos: { name: string, svg: string }[] }} */
    props
) => {
    return (
        <div className="PartnerLogoBox">
            <div className="detailview-partner">Partner</div>
            <div className="partner-box">
                {
                    (props.logos || []).map((item, index) => {
                        if (item) {
                            return (
                                <div className='partner-container' key={index}>
                                    <img src={item.svg} alt={item.name} />
                                </div>
                            )
                        }
                    })
                }
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/ads/app/appchallengecenter/PartnerLogoBox.js